export const surface = {
  flat: {
    background: 'var(--vn-surface-card)',
    border: 'none',
    shadow: 'none',
    hoverBackground: 'var(--vn-surface-card-hover)',
    hoverBorder: 'none',
    hoverShadow: 'none',
  },
  outlined: {
    background: 'var(--vn-surface-card)',
    border: '1px solid var(--vn-border-default)',
    shadow: 'none',
    hoverBackground: 'var(--vn-surface-card)',
    hoverBorder: '1px solid var(--vn-border-strong)',
    hoverShadow: 'none',
  },
  elevated: {
    background: 'var(--vn-surface-card)',
    border: '1px solid transparent',
    shadow: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
    hoverBackground: 'var(--vn-surface-card)',
    hoverBorder: '1px solid transparent',
    hoverShadow: '0 4px 16px rgba(0,0,0,0.1)',
  },
} as const;

export type SurfaceVariant = keyof typeof surface;
